import React, { useState } from "react";
import "../../styles/index.css";
import EditStudyPlanner from "../PopUp/StudyPlaner/EditStudyPlanner";
import DeleteStudyPlanner from "../PopUp/StudyPlaner/DeleteStudyPlanner";
/**
 * Displays AddClassMaterial for day view
 * @param {*} param0
 * @returns
 */
const Upcoming = ({ event }) => {
  const [clicked, setClicked] = useState(false);
  const [deletePlanner, setDeletePlanner] = useState(false);
  const close = () => {
    setClicked(false);
  };
  return event.Events[0] !== "Planner" ? (
    <div className=" summary_con col"></div>
  ) : (
    <>
      <div className=" summary_con col-2 pr-5">
        <div
          onClick={(e) => {
            e.stopPropagation()
            setDeletePlanner(true);
          }}
        >
          <img
            src="/DCM-img/delete.svg"
            alt=""
            className="mr-4"
          ></img>
        </div>
        <button
          className="edtbtn"
          onClick={(e) => {
            e.stopPropagation()
            setClicked(true);
          }}
        >
          Edit Planner
        </button>
      </div>
      {clicked && <EditStudyPlanner event={event} setClicked={setClicked} />}
      {deletePlanner && <DeleteStudyPlanner event={event} close={setDeletePlanner} />}
    </>
  );
};

export default Upcoming;
